// extracted by mini-css-extract-plugin
export var container = "_hv-1";
export var cornerButtonContainer = "_hv-6";
export var disabled = "_hv-2";
export var dragActive = "_hv-3";
export var fileContainer = "_hv-5";
export var hiddenInput = "_hv-4";
export var widthContainer = "_hv-0";